import productsAPI from "@/api/products";

const state = () => ({
  hasNoEnterprise: true,
  enterpriseConfiguration: {
    call_restriction: "",
    international_call_barring: null,
  },
  enterpriseConfigurationLoading: false,
  enterpriseConfigurationError: false,
  enterpriseConfigurationErrorMsg: null,
  internationalCallingSendToServer: false,
  internationCallingCanEditStatus: ["Provisioned", "Ready", "Live", "Bad Debt", "Blocked Bad Debt", "Pending Cease Bad Debt"],
  hasInternationalAddonsInEdit: false,
});

const mutations = {
  ENTERPRISE_CONFIGURATION_LOADING(state) {
    state.enterpriseConfigurationError = false;
    state.enterpriseConfigurationErrorMsg = null;
    state.enterpriseConfigurationLoading = true;
  },

  ENTERPRISE_CONFIGURATION_SUCCESS(state, payload) {
    state.hasNoEnterprise = false;
    state.enterpriseConfiguration = {
      call_restriction: payload.call_restriction,
      international_call_barring: payload.international_call_barring
    };
    state.enterpriseConfigurationError = false;
    state.enterpriseConfigurationErrorMsg = null;
    state.enterpriseConfigurationLoading = false;
  },
  
  ENTERPRISE_CONFIGURATION_FAILURE(state, payload) {
    state.hasNoEnterprise = true;
    state.enterpriseConfigurationError = true;
    state.enterpriseConfigurationErrorMsg = payload.data;
    state.enterpriseConfigurationLoading = false;
  },
  
  UPDATE_HAS_INT_CALLS_IN_EDIT(state, payload) {
    state.hasInternationalAddonsInEdit = !!payload;
  },
  
  CLEAR_ENTERPRISE_CONFIGURATION(state) {
    state.hasNoEnterprise = true;
    state.enterpriseConfiguration = {
      call_restriction: "",
      international_call_barring: null,
    };
    state.enterpriseConfigurationError = false;
    state.enterpriseConfigurationErrorMsg = null;
    state.enterpriseConfigurationLoading = false;
  }
};

const actions = {
  async fetchEnterpriseConfiguration({ commit }, payload) {
    commit("CLEAR_ENTERPRISE_CONFIGURATION");
    commit("ENTERPRISE_CONFIGURATION_LOADING");
    try {
      const response = await productsAPI.getEnterpriseConfiguration(payload);
      commit("ENTERPRISE_CONFIGURATION_SUCCESS", response.data);
    } catch(err) {
      commit("ENTERPRISE_CONFIGURATION_FAILURE", err.response.data);
      throw err;
    }
  },

  async updateEnterpriseConfiguration({ commit, dispatch }, { id, data }) {
    commit("ENTERPRISE_CONFIGURATION_LOADING");
    try {
      const response = await productsAPI.updateEnterpriseConfiguration(id, data);
      commit("ENTERPRISE_CONFIGURATION_SUCCESS", response.data);
    } catch(err) {
      commit("ENTERPRISE_CONFIGURATION_FAILURE", err.response.data);
      dispatch("alerts/setAlert", {
        type: "error",
        message: err.response.data.message,
      }, { root: true });
      throw err;
    }
  },

  hasInternationalCallsInEdit({ commit }, payload) {
    commit("UPDATE_HAS_INT_CALLS_IN_EDIT", payload);
  },

  clearIntCalling({ commit }) {
    commit("CLEAR_ENTERPRISE_CONFIGURATION");
  }
};

const getters = {
  getHasNoEnterprise: state => state.hasNoEnterprise,
  getEnterpriseConfiguration: state => state.enterpriseConfiguration,
  getEnterpriseConfigurationLoading: state => state.enterpriseConfigurationLoading,
  getEnterpriseConfigurationError: state => state.enterpriseConfigurationError,
  getEnterpriseConfigurationErrorMsg: state => state.enterpriseConfigurationErrorMsg,
  getHasInternationalCallsInEdit: state => state.hasInternationalAddonsInEdit,
  getHasInternationalAddons: (state, getters, rootState) => {
    const voipSiteAddons = rootState.products.voipSiteAddons;
    const currentProductAddons = rootState.products.currentProduct.addons;
    let hasInternationalAddons = false;
    currentProductAddons.forEach((productAddon) => {
      voipSiteAddons.forEach((voipSiteAddon) => {
        if(productAddon.addon_id === voipSiteAddon.id && productAddon.quantity > 0) {
          if(voipSiteAddon.display_group === "voip_international_calls") {
            hasInternationalAddons = true;
          }
        }
      });
    });
    return hasInternationalAddons;
  },
  getInternationalCallsCanEditStatus: (state, getters, rootState) => {
    const productStatus = rootState.products.currentProduct.status;
    return state.internationCallingCanEditStatus.includes(productStatus);
  },
  getHasPlatformId: (state, getters, rootState) => {
    const platformId = rootState.products.currentVoipSite.platform_id;
    return !!platformId;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  